/* ================================================================
   Mehrfachauswahl in Filtern — reine Regeln, ohne React.

   Ein Filter hält statt eines einzelnen Werts eine Liste gewählter
   Werte. Leer heißt „alle". Innerhalb EINES Filters verbinden sich
   die Werte mit ODER (2019 oder 2021), verschiedene Filter wie
   bisher mit UND (Rot und 2019-oder-2021). Nur so ergibt eine
   Mehrfachwahl Sinn: Ein Jahrgang ist nie zugleich 2019 und 2021.

   Gespeichert und verglichen wird immer als Zeichenkette. Jahrgänge
   sind Zahlen (N.V. ist 0), Optionswerte aus dem DOM sind Text — wer
   beides mischt, findet seine eigene Wahl nicht wieder.

   Die Regeln stehen hier und nicht in den Ansichten, weil Keller,
   Weinliste, Winzer, Regionen und die geteilten Ansichten sie alle
   brauchen und sie sonst fünfmal leicht verschieden ausfielen.
   ================================================================ */

/* Bringt einen Filterwert in die Listenform. Ein einzelner Wert
   (etwa aus einer Verlinkung „Im Keller zeigen") wird zur
   einelementigen Liste, "" und null zur leeren. */
function alsWahl(v) {
  if (Array.isArray(v)) return v.map(String);
  if (v == null || v === "") return [];
  return [String(v)];
}

/* Leere Wahl lässt alles durch, sonst muss der Wert darin stehen. */
function passtWahl(wahl, wert) {
  if (!wahl || wahl.length === 0) return true;
  if (wert == null) return false;
  return wahl.includes(String(wert));
}

/* Für Merkmale mit mehreren Werten je Objekt — Rebsorten eines
   Weins, Jahrgänge in der weinweisen Liste: Es genügt EIN Treffer. */
function passtEinerWahl(wahl, werte) {
  if (!wahl || wahl.length === 0) return true;
  for (const w of werte || []) if (w != null && wahl.includes(String(w))) return true;
  return false;
}

/* Wie passtEinerWahl, aber mit eigener Prüfung je gewähltem Wert —
   für Merkmale, deren Vergleich nicht bloße Gleichheit ist
   (hatRebsorte vergleicht ohne Groß-/Kleinschreibung). */
function passtWahlMit(wahl, pruefe) {
  if (!wahl || wahl.length === 0) return true;
  return wahl.some(pruefe);
}

/* Einen Wert an- oder abwählen. Die Reihenfolge der übrigen bleibt. */
function umschalten(wahl, wert) {
  const w = String(wert);
  return wahl.includes(w) ? wahl.filter((x) => x !== w) : [...wahl, w];
}

/* Optionsliste so ergänzen, dass jede gewählte Wahl darin steht.
   Die Listen kaskadieren: Wer erst Region und dann ein anderes Land
   wählt, dessen Region fiele aus der Liste — und wäre dann gewählt,
   aber nirgends zu sehen und nicht mehr abzuwählen. */
function mitGewaehlten(optionen, wahl, beschrifte = (w) => w) {
  const da = new Set(optionen.map((o) => String(o.wert)));
  const fehlend = wahl.filter((w) => !da.has(w)).map((w) => ({ wert: w, label: beschrifte(w) }));
  return fehlend.length ? [...optionen, ...fehlend] : optionen;
}

/* Text im Knopf: „Alle …", ein Name, oder der erste Name und „+n".
   Der erste in der Reihenfolge der Liste, nicht der zuerst
   angeklickte — sonst wechselt die Anzeige beim Abwählen sprunghaft. */
function kurzText(wahl, optionen, alleText) {
  if (!wahl || wahl.length === 0) return alleText;
  const gewaehlt = optionen.filter((o) => wahl.includes(String(o.wert)));
  const erster = gewaehlt.length ? gewaehlt[0].label : wahl[0];
  return wahl.length === 1 ? String(erster) : `${erster} +${wahl.length - 1}`;
}

/* Volltext für den Titel des Knopfs (Kurzhinweis, Vorlesewerkzeuge). */
function langText(wahl, optionen, alleText) {
  if (!wahl || wahl.length === 0) return alleText;
  const gewaehlt = optionen.filter((o) => wahl.includes(String(o.wert))).map((o) => o.label);
  return gewaehlt.length ? gewaehlt.join(", ") : wahl.join(", ");
}

export { alsWahl, kurzText, langText, mitGewaehlten, passtEinerWahl, passtWahl, passtWahlMit, umschalten };
